// react
import React from 'react'
// antd-pro
import {ProFormSelect, ProFormText} from '@ant-design/pro-components'
import Api from '@/api'
import {AppType} from '@/enum'

/**
 * 诺诺配置表单项
 * @constructor
 */
const HSDianDangFormItems = () => {
  return (
    <>
      <ProFormText
        name={["config", "appKey"]}
        label={"AppKey"}
        placeholder={"请输入appKey"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入appKey"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "appSecurity"]}
        label={"AppSecurity"}
        placeholder={"请输入appSecurity"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入appSecurity"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "serverUrl"]}
        label={"serverUrl"}
        placeholder={"请输入serverUrl"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入serverUrl"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "remark"]}
        label={"remark"}
        placeholder={"请输入remark"}
        width={"lg"}
        rules={[
          {
            message: "请输入remark"
          }
      ]}
      />
    </>
  )
}

export default HSDianDangFormItems
